import * as React from 'react';
import * as _ from 'lodash'
import config from '../../../constants/config';
import {  AxiosInstance } from '../../../utils/RequestMethods';
import { CompanyT } from '../../../types/Company';
import { Container, Image, Spinner } from 'react-bootstrap';
import { initUserObj } from '../../../types/Users';
import { WorkerObj } from '../../../types/Worker';
import images from '../../../constants/images';
import ButtonLoading from '../../../components/ButtonLoading/ButtonLoading';

export type ICompanyWorkerLineItemProps = {
    workerId: number
    company: CompanyT
    updateCompany(company: CompanyT): void

}

const CompanyWorkerLineItem: React.FC<ICompanyWorkerLineItemProps> = ({ workerId, company, updateCompany }) => {
    const [isLoading, setIsLoading] = React.useState(false);
    const [worker, setWorker] = React.useState(Object.assign({}, WorkerObj))
    const [currentWorkerId, setCurrentWorkerId] = React.useState(null)
    const salesCall = company.salesCall && _.isArray(company.salesCall) ? company.salesCall : []
    React.useEffect(() => {
        if (!_.isEqual(currentWorkerId, workerId)) {
            fetchData()
            setCurrentWorkerId(workerId)
        }

    }, [workerId])


    /**
     *
     */
    const isExistsInSalesCall = () => {
        return salesCall.find((x) => x == workerId)
    }

    const fetchData = async () => {
        setIsLoading(true)
        let options={
          data:{}
        }
        AxiosInstance.get(`${config.url.workers}/${workerId}`).then((res) => {
            setIsLoading(false)
            if (res && res.data) {
                setWorker(res.data)
            }
        }).catch((error) => {
            setIsLoading(false)
        })
    }

    /**
     *
     */
    const saveSalesCall = async (): Promise<string> => {
        const type = isExistsInSalesCall() ? 'delete' : 'add'

        const params = {
            type: type,
        }
        return AxiosInstance.post(`${config.url.companies}/${company.id}/workers/${worker.id}/sales-call`, params).then((res) => {
            if (res && res.data) {
                updateCompany(res.data)
            }
            const message = type == 'add' ? 'Add worker to' : 'Delete worker from'
            return `${message} sales call`
        })
    }

    if (isLoading) {
        return (
            <Container className="mt-5 text-center">
                <Spinner animation="border" variant="info" />
                Loading ...
            </Container>
        )
    }
    if (worker.id == null || worker.id == 0) {
        return null;
    }
    return (
        <div className="d-flex p-2 ">
            <div className="p-2">
                <Image style={{
                    height: 40,
                    padding: 2,
                    width: 40
                }} src={worker.profilePic ? worker.profilePic : images.noProfilePic} />
                <span> {worker.firstName}  {worker.lastName}</span>
            </div>

            <div className="d-flex ml-2 p-2 align-items-end">
                <ButtonLoading onClickFetching={saveSalesCall} className={`btn btn-sm ${isExistsInSalesCall() ? 'btn-danger' : 'btn-primary'}`}>
                    {!isExistsInSalesCall() ? `Add to Sales Call list` : `Delete to Sales Call list`}
                </ButtonLoading>
            </div>

        </div>
    );
}

export default CompanyWorkerLineItem;
export { CompanyWorkerLineItem };
